import React from "react";
import InventoryComponent from "./InventoryComponent";
import Uri from "../../Network/Uri";
import postClientDataResponse from "../../Network/PostClientDataResponse";
import getResponseClient from "../../Network/GetClientDataResponse";
import {
  ADD_DAILYINVENTORY,
  GET_DAILYINVENTORY,
  DELETE_DAILYINVENTORY,
  GET_INVENTORYPRODUCTS,
  UPDATE_DAILYINVENTORY,
} from "../../Network/ApiPaths";

let storeFresh;
let clientHost;

class InventoryContainer extends React.Component {
  constructor(props) {
    super(props);

    const client = JSON.parse(localStorage.getItem("clientAccess"));
    storeFresh = client;
    clientHost = client?.host;

    this.state = {
      inventory: [],
      products: [],
      productId: "",
      request_date: "",
      quantity: "",
      
    };
  }

  componentDidMount() {
    const today = new Date().toISOString().split("T")[0];
    this.setState({ request_date: today });

    this.getInventory();
    this.getProducts();
  }

  onProductChange = (e) => this.setState({ productId: e.target.value });
  onDateChange = (e) => this.setState({ request_date: e.target.value });
  onQuantityChange = (e) => this.setState({ quantity: e.target.value });

  addInventory = (e) => {
    e.preventDefault();

    const body = {
      inventory_item_id: this.state.productId,
      request_date: this.state.request_date,
      quantity: this.state.quantity,
      store_id: storeFresh.storeId,
    };

    postClientDataResponse(
      clientHost + ADD_DAILYINVENTORY,
      storeFresh.key,
      body,
      () => this.getInventory(),
      (err) => console.log(err)
    );
  };
  

  getInventory = () => {
    const apiPath = new Uri(clientHost + GET_DAILYINVENTORY).addQueryParam(
      "store_id",
      storeFresh.storeId
    );
    getResponseClient(
      apiPath,
      storeFresh.key,
      (res) => this.setState({ inventory: res.result }),
      (err) => console.log(err)
    );
  };
updateInventory = (e) => {
    e.preventDefault();

    const body = {
      inventory_item_id: this.state.productId,
      request_date: this.state.request_date,
      quantity: this.state.quantity,
      store_id: storeFresh.storeId,
    };

    postClientDataResponse(
      clientHost + UPDATE_DAILYINVENTORY,
      storeFresh.key,
      body,
      () => this.updateInventorydata(),
      (err) => console.log(err)
    );
  };
  updateInventorydata = () => {
    const apiPath = new Uri(clientHost + UPDATE_DAILYINVENTORY).addQueryParam(
      "store_id",
      storeFresh.storeId
    );
    getResponseClient(
      apiPath,
      storeFresh.key,
      (res) => this.setState({ inventory: res.result }),
      (err) => console.log(err)
    );
  };

  getProducts = () => {
    const apiPath = new Uri(
      clientHost + GET_INVENTORYPRODUCTS
    ).addQueryParam("store_id", storeFresh.storeId);

    getResponseClient(
      apiPath,
      storeFresh.key,
      (res) => this.setState({ products: res.result }),
      (err) => console.log(err)
    );
  };

  deleteInventory = (id) => {
    const apiPath = new Uri(clientHost + DELETE_DAILYINVENTORY).addQueryParam(
      "id",
      id
    );

    getResponseClient(
      apiPath,
      storeFresh.key,
      () => this.getInventory(),
      (err) => console.log(err)
    );
  };

  render() {
    return (
      <InventoryComponent
        inventory={this.state.inventory}
        products={this.state.products}
        onProductChange={this.onProductChange}
        onDateChange={this.onDateChange}
        onQuantityChange={this.onQuantityChange}
        addInventory={this.addInventory}
        updateInventory={this.updateInventory}
        deleteInventory={this.deleteInventory}
        
      />
    );
  }
}

export default InventoryContainer;
